/**
 * App Users Module Constants
 */

// User pool constant for app users
export const APP_USER_POOL = 'app'

// Default pagination settings
export const DEFAULT_PAGE_SIZE = 10
export const DEFAULT_PAGE = 0

// Default filter state for user list
export const DEFAULT_USER_FILTER = {
    active: null,
}

// Default filter state for bookings
export const DEFAULT_BOOKING_FILTER = {
    booking_code: '',
    from_date: null, // Will be set dynamically
    to_date: null,   // Will be set dynamically
}
